import { bootstrapApp } from "../bootstrapApp";
import { Home, Subscriptions, Video, WatchDetails } from "../Pages";
export const routes = {
    boot: bootstrapApp,
    root: "home",
    routes: [
        {
            before: async (page) => Home.getData(page),
            // Static demo data: retain the rails and their focus while Home is cached.
            cache: Infinity,
            component: Home,
            path: "home",
            widgets: ["navbar"],
        },
        {
            component: Video,
            path: "video",
        },
        {
            component: Subscriptions,
            path: "subscribe/:competition",
        },
        {
            component: WatchDetails,
            path: "watch-details",
            widgets: ["navbar"],
        },
    ],
};
export default routes;
//# sourceMappingURL=index.js.map